var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7,
    fill: "#F1EDFF",
    stroke: "#E3DCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5671 11.7452H14.2293C13.3968 11.7452 12.9802 11.7452 12.6622 11.9072C12.3825 12.0497 12.1553 12.2769 12.0128 12.5566C11.8508 12.8746 11.8508 13.2912 11.8508 14.1237V19.7722C11.8508 20.6047 11.8508 21.0208 12.0128 21.3387C12.1553 21.6184 12.3825 21.846 12.6622 21.9885C12.9799 22.1504 13.3959 22.1504 14.2268 22.1504H19.8799C20.7108 22.1504 21.1263 22.1504 21.4439 21.9885C21.7236 21.846 21.9516 21.6182 22.0941 21.3385C22.256 21.0208 22.256 20.6052 22.256 19.7744V18.4342M22.9992 14.7181V11.002M22.9992 11.002H19.2831M22.9992 11.002L17.7966 16.2046",
    stroke: "#5B489D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPage);
export default __webpack_public_path__ + "static/media/nextPage.7670bf001079146f5c978b208f6d929a.svg";
export { ForwardRef as ReactComponent };